import React, { Component } from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { compose } from 'recompose';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import BuildIcon from '@material-ui/icons/Build';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import {
  DASHBOARD,
  RENTERS,
  BIKES,
  SITES,
  RENTS,
  USERS,
  VOUCHERS,
  BOOKINGS,
  BOOKINGS_LLD,
  RENT_LLD, FEEDBACKS,
} from '../../constants/routes';
import { ROLE_ADMIN, ROLE_USER } from '../../constants/roles';
import { KOBOO_LIGHT_GREY, KOBOO_OTHER_BLUE } from '../../constants/colors';
import withAuthorization from '../../hoc/withAuthorization';

const styles = () => ({
  informationMenuItem: {
    backgroundColor: KOBOO_OTHER_BLUE,
    borderRadius: '0 2em 2em 0',
  },
  linkMenuItem: {
    borderRadius: '0 2em 2em 0',
  },
  selectedItems: {
    color: KOBOO_LIGHT_GREY,
  },
  menuText: {
    color: 'inherit',
    marginBottom: 0,
  },
});


const ItemSinglePath = props =>
  <MenuItem
    component={Link}
    to={props.path}
    classes={{ root: props.classes.linkMenuItem, selected: props.classes.selectedItems }}
    selected={props.location.pathname === props.path}
  >
    <Typography
      variant="subtitle1"
      gutterBottom
      className={props.classes.menuText}>
      {props.label}
    </Typography>
  </MenuItem>;

const ItemMultiPath = props =>
  <MenuItem
    component={Link}
    to={props.path}
    classes={{ root: props.classes.linkMenuItem, selected: props.classes.selectedItems }}
    selected={props.location.pathname.includes(props.path)}
  >
    <Typography
      variant="subtitle1"
      gutterBottom
      className={props.classes.menuText}
    >
      {props.label}
    </Typography>
  </MenuItem>;

export class RentMenuItems extends Component {
  state={
    role: ROLE_USER,
  };

  static getDerivedStateFromProps(props) {
    let newState = null;
    if (props.authUser && props.roles) {
      newState = { ...newState, role: props.roles[props.authUser.uid] };
    }
    return newState;
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        {process.env.REACT_APP_ENV &&
        <ListItem className={classes.informationMenuItem}>
          <ListItemIcon>
            <BuildIcon />
          </ListItemIcon>
          <ListItemText inset primary={process.env.REACT_APP_ENV} />
        </ListItem>}
        <ItemSinglePath
          path={DASHBOARD}
          classes={classes}
          label="Dashboard"
          location={this.props.location}
        />
        <ItemMultiPath
          path={USERS}
          classes={classes}
          label="Clients"
          location={this.props.location}
        />
        {this.state.role === ROLE_ADMIN &&
        <ItemMultiPath
          path={RENTERS}
          classes={classes}
          label="Loueurs"
          location={this.props.location}
        />
        }
        <ItemMultiPath
          path={RENTS}
          classes={classes}
          label="Locations"
          location={this.props.location}
        />
        <ItemMultiPath
          path={RENT_LLD}
          classes={classes}
          label="Locations longue durée"
          location={this.props.location}
        />
        <ItemMultiPath
          path={BIKES}
          classes={classes}
          label="Vélos"
          location={this.props.location}
        />
        <ItemMultiPath
          path={SITES}
          classes={classes}
          label="Sites"
          location={this.props.location}
        />
        <ItemMultiPath
          path={VOUCHERS}
          classes={classes}
          label="Coupons"
          location={this.props.location}
        />
        <ItemMultiPath
          path={BOOKINGS}
          classes={classes}
          label="Réservations"
          location={this.props.location}
          />
        <ItemMultiPath
          path={BOOKINGS_LLD}
          classes={classes}
          label="Réservations longue durée"
          location={this.props.location}
        />
        <ItemMultiPath
          path={FEEDBACKS}
          classes={classes}
          label="Satisfaction client"
          location={this.props.location}
        />
      </div>
    );
  }
}

const authCondition = authUser => !!authUser;

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
  };
}
export default compose(
  withRouter,
  connect(mapStateToProps),
  withStyles(styles),
  withAuthorization(authCondition),
)(RentMenuItems);



// WEBPACK FOOTER //
// ./src/components/Menu/RentMenuItems.jsx